export const Style = ({
    container: {
        display:'flex', 
        justifyContent:'center', 
        alignItems:'center', 
        minHeight:'80vh'
    },
    
});